import React from "react";
import { useSelector } from "react-redux";
import { Localize } from "../../../shared/ariaLabelLocalize";

const FOCUSABLE_SELECTOR =
    'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

const SkipLink = () => {
    const languageId = useSelector((state) => state.language?.selectedlanguage?.id);
    const localised = Localize[languageId] || Localize['en_US'];
    const handleClick = (e) => {
        e.preventDefault();
        const main = document.getElementById("main-content");
        if (!main) return;
        // Preferred landing: the first heading inside main. This is the
        // semantic start of content — screen readers announce the heading
        // text, sighted keyboard users see a focus ring (if the heading is
        // visible), and next Tab enters the interactive content. Falls
        // through to `<main>` itself, then to the first visible focusable
        // descendant, so pages without a heading still get useful focus.
        const heading = main.querySelector('h1, h2, h3, h4, h5, h6');
        if (heading) {
            if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
            heading.focus({ preventScroll: true });
            if (document.activeElement === heading) return;
        }
        main.focus({ preventScroll: true });
        if (document.activeElement === main) return;
        // Filter by `offsetParent` so we don't pick something inside a
        // `display: none` ancestor (e.g. Login's Bootstrap-collapsed "Login
        // with your credentials" button) — `.focus()` on hidden elements is a
        // silent no-op.
        for (const el of main.querySelectorAll(FOCUSABLE_SELECTOR)) {
            if (el.offsetParent !== null) { el.focus({ preventScroll: true }); return; }
        }
    };

    return (
        <a href="#main-content" className="skip-link" onClick={handleClick}>
            {localised.skip_to_main_content}
        </a>
    );
};

export default SkipLink;
